import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IASEntryCreateParams } from "../models/shortage";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Update All Shortage entry and return same object
 */

export const UpdateASEntryAPI = async (params: IASEntryCreateParams, osdNumber?: number | string) => {
  try {
    // Get static headers from map (do not use || {})
    const staticHeaders = getTrackingHeadersMap(ApiType.AS_ENTRY_UPDATE);
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber?.toString(),
      "OSD-Reporting-Terminal": params?.reporting,
      "OSD-Origin-Terminal": params?.origin,
      "OSD-Destination-Terminal": params?.destination,
    };
    const response = await axios.put(`${getUrl(ApiType.AS_ENTRY_UPDATE)}/${osdNumber}`, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.updateASEntry, { badRequestOrder: "errorsFirst" });
  }
};
